module.exports = __webpack_public_path__ + "img/img9.0e4d2f4f.jpg";